<script>
export default {
	data: () => ({
		state: '',
		activeLink: '',
		offset: 0,
		limit: 15,
		searchString: '',
		serviceProviderClicked: false,
		isChangeDefault: false,
		ticketOptionProducts: [],
		selectedOption: null,
		sections: [
			{ id: 'serviceProviders',    state: 'valid', preventDefault: true },
			{ id: 'ticketType',          state: 'valid', preventDefault: true, operatorAllowed: true },
			{ id: 'reduction',           state: 'valid', preventDefault: true, operatorAllowed: true, path: '/reductions' },
			{ id: 'checklist',           state: 'valid', preventDefault: true },
			{ id: 'categories',          state: 'valid', preventDefault: true, path: '/productCategory' },
			{ id: 'marketplaceSettings', state: 'valid', preventDefault: true },
			{ id: 'commissions',         state: 'valid', preventDefault: true },
		],
		errorTitle: '',
		errorDetail: '',
		errorAlertVisible: false,
		successTitle: '',
		successDetail: '',
	}),
	computed: {
		isOperator() {
			return this.$store.state.loggedInUser?.fields?.type?.de === 'operator' && !this.$store.state.isImpersonation
		},
		states() {
			if (this.userIsOperator) {
				return ["serviceProviders", "ticketType", "reduction", "checklist", "categories", "marketplaceSettings", "generalSettings"]
			} else {
				return ["ticketType", "reduction", "faq"]
			}
		},
	},
	methods: {
		changeState(state) {
			this.state = state
			this.itemType = state
			this.offset = 0
			this.searchString = ''
		},
		// this is triggered by the sidebar actions
		handleAction(event) {
			// function is typically "setActive"
			this[event.function](event.params)
		},
		setActive(key, skipNavigation = false) {
			const section = this.sections.find(x => x.id == key)
			this.activeLink = key
			this.state = key
			this.itemType = key
			this.serviceProviderClicked = false
			const shouldUseDedicatedPath = section?.path
			const currentPath = this.$route.path
			const currentViewType = this.$route.query?.viewType

			if (!skipNavigation && shouldUseDedicatedPath) {
				if (currentPath !== section.path) {
					this.$router.replace(section.path)
				}
			}
			else if (!skipNavigation) {
				const isSameSettingsTarget = currentPath === '/settings' && currentViewType === key
				if (!isSameSettingsTarget) {
					this.$router.replace({ path: '/settings', query: { viewType: key } })
				}
			}
			this.changeState(key)
		},
		setSections() {
			if (!this.userIsOperator) {
				if (!this.$store.state.featureFlags.FEATURE_FAQ_IN_SERVICES) {
					this.sections.push({ id: 'faq', state: 'valid', preventDefault: true, operatorAllowed: true })
				}

				this.sections = this.sections.filter(a => a.operatorAllowed)
			}
			else {
				if (this.$store.state.featureFlags.FEATURE_GENERAL_SETTINGS) {
					this.sections.push({ id: 'generalSettings', state: 'valid', preventDefault: true, operatorAllowed: true })
				}
			}
		},
		async checkOptionsProduct(option, itemType) {
			this.loading = true
			// option.defaultAssignment is the new value, so we need to check for false here
			if (!option.defaultAssignment) {
				try {
					const res = await this.$httpGet(`/check-option-products?optionId=${option.sys.id}&itemType=${itemType}`)
					if (res.length) {
						this.selectedOption = option
						this.ticketOptionProducts = res
						this.$refs.ticketOptionProductsDialog.show()
					} else {
						await this.changeDefault(option)
					}
				}
				catch (error) {
					if (error.response?.status === 401) return this.$emit('show-login')
					this.showError(error.response ? error.response.data.error : error)
					option.defaultAssignment = false
				}
			} else {
				await this.changeDefault(option)
			}
			this.loading = false
		},
		async changeDefault(option) {
			this.loading = true

			if (!option.defaultAssignment) {
				option.defaultAssignment = false
			}

			var data = {
				clientId: this.$store.state.selectedClient.sys.id,
				optionId: option.sys.id,
				defaultAssignment: option.defaultAssignment,
			}

			try {
				const res = await this.$httpPost('/default-assignment', data)
				this.$store.state.selectedClient.fields.defaultAssignments.de = res.client.fields.defaultAssignments.de

				if (this.searchString?.length > 0) {
					this.search()
				}
			}
			catch (error) {
				if (error.response && error.response.status === 401) {
					this.$emit('show-login')
				}
				this.errorTitle = this.$t('text.ERROR')
				if (error.response) {
					this.errorDetail = error.response.data.error
				}
				else {
					this.errorDetail = error
				}
			}
			this.loading = false
		},
		onOptionProductWarningConfirmed() {
			this.$refs.ticketOptionProductsDialog.hide()
			this.changeDefault(this.selectedOption)
		},
		onOptionProductWarningCancelled() {
			this.selectedOption.defaultAssignment = true
		},
	}
}
</script>
